import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { AppraisalService } from '../services/appraisal.service';

@Component({
  selector: 'app-assign-l2',
  templateUrl: './assign-l2.component.html',
  styleUrls: ['./assign-l2.component.css']
})
export class AssignL2Component implements OnInit {

   employee_code;
   emplyoeeCodeData;
   form_id;
   l2_dd;
  constructor(private route: ActivatedRoute, private apprais : AppraisalService, private router: Router) { }
  clickStatus = false;
  alreadySubmit = false;

  userData = {
    id : '',
    employee_code : '',
    form_id: '',
    employee_name : '',
    l2_employee_code : ''
  }


  ngOnInit() {
    this.employee_code = this.route.snapshot.params.employee_code;
    this.form_id = this.route.snapshot.params.form_id;
    //console.log(this.employee_code);
    this.emplyoeeCodeData = {
      employee_code: this.employee_code,
      form_id: this.form_id
    }
    this.apprais.getEmployeeAndL2(this.emplyoeeCodeData).subscribe(res=>{
      //console.log(JSON.stringify(res));
      //console.log(res.user.employee_code);
      this.userData.form_id = this.form_id;
      this.userData.id = res.user.id;
      this.userData.employee_code = res.user.employee_code_app;
      this.userData.employee_name = res.user.employee_name_app;
      this.userData.l2_employee_code = res.user.l2_employee_code;
      this.l2_dd = res.l2dd;
   
  });
    
  }

  isValid(assignL2Form,control) 
  {
   
    if((!assignL2Form.controls[control].valid && (assignL2Form.controls[control].dirty ||assignL2Form.controls[control].touched)) || (!assignL2Form.controls[control].valid && this.clickStatus))
    {
       //var errorStr = '<div class="alert alert-danger"> * ' + control+ ' is required</div>';
       var errorStr = '<div class="alert alert-danger"> * ' + 'This field is required</div>';
      return errorStr;
    }
  }

  onSubmit(assignL2Form)
  {
    this.clickStatus = true;
    if(assignL2Form.valid)
    {
     this.alreadySubmit = true;
    // console.log(this.userData);
     var setrole = this.apprais.setL2Code(this.userData).subscribe( res => {
      localStorage.setItem('appraisal_msg',res.message);
      this.router.navigate(['/selfAppraisalAssign']);
     })
     
      
    }
   
   
  }


}



// WEBPACK FOOTER //
// ./src/app/assign-l2/assign-l2.component.ts